import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Checkbox, { CheckboxPresentationProps } from "@insite/mobius/Checkbox";
import CheckboxGroup, { CheckboxGroupComponentProps } from "@insite/mobius/CheckboxGroup";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { FieldSetGroupPresentationProps } from "@insite/mobius/utilities/fieldSetProps";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import React, { FC } from "react";
import { css } from "styled-components";

export interface CartLinesListHeaderStyles {
    wrapper?: InjectableCss;
    productCountText?: TypographyPresentationProps;
    productListHeading?: TypographyPresentationProps;
    checkboxGroup?: FieldSetGroupPresentationProps<CheckboxGroupComponentProps>;
    condensedCheckbox?: CheckboxPresentationProps;
}

export const cartLinesListHeaderStyles: CartLinesListHeaderStyles = {
    wrapper: {
        css: css`
            display: flex;
            justify-content: space-between;
            /* border-bottom: 1px solid ${getColor("common.border")};
            padding-bottom: 10px; */
            flex-direction: column;
            margin-bottom: -8px;
        `,
    },
    productCountText: {
        weight: 600,
        fontFamily: "Lato",
        css: css`
            padding: 0rem 1rem;
            @media print {
                font-weight: lighter;
                font-size: 16px;
            }
        `,
    },
    productListHeading: {
        variant: "h2",
        color: "primary",
        css: css`
            margin-bottom: 10px;
            padding: 0.5rem 1rem;
            font-size: 1.25rem;
            font-family: "LibreBaskerville";
            font-weight: normal;
            margin-right: auto;
            background-color: #f0f4f3;
            width: 100%;
            @media print {
                font-size: 24px !important;
                width: 100vw;
            }
        `,
    },
    checkboxGroup: {
        css: css`
            @media print {
                display: none;
            }
        `,
    },
};

const CartLinesListHeader: FC<{
    productsCount: number;
    isCondensed: boolean;
    hideCondensedSelector?: boolean;
    onChangeIsCondensed?: (event: React.SyntheticEvent, value: boolean) => void;
    extendedStyles?: CartLinesListHeaderStyles;
}> = ({ productsCount, onChangeIsCondensed, extendedStyles, isCondensed, hideCondensedSelector }) => {
    const [styles] = React.useState(() => mergeToNew(cartLinesListHeaderStyles, extendedStyles));

    const productsLabel = productsCount > 1 ? "Items" : "Item";

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.productListHeading}>{translate("Product Information")}</Typography>
            <Typography {...styles.productCountText} as="h3">
                {productsCount} {translate(productsLabel)}
            </Typography>
            {/* Uncomment below code for condensed view checkbox */}
            {/* {!hideCondensedSelector && (
                <CheckboxGroup {...styles.checkboxGroup}>
                    <Checkbox {...styles.condensedCheckbox} checked={isCondensed} onChange={onChangeIsCondensed}>
                        {translate("Condensed View")}
                        <VisuallyHidden>{translate("for product list")}</VisuallyHidden>
                    </Checkbox>
                </CheckboxGroup>
            )} */}
        </StyledWrapper>
    );
};

export default CartLinesListHeader;
